import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@prio365/prio365-react-library';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'react-jss';
import Flex from '../../../../../../components/Flex';
import { PrioTheme } from '../../../../../../theme/types';
import { makePrioStyles } from '../../../../../../theme/utils';

const useStyles = makePrioStyles((theme) => ({
  root: {},
  sectionHeader: {
    borderBottom: `1px solid ${theme.colors.application.border}`,
    paddingBottom: theme.spacing.extraSmall,
    margin: `${theme.spacing.large}px 0px ${theme.spacing.regular}px 0px`,
  },
  sectionHeading: {
    fontSize: theme.font.fontSize.small,
    fontWeight: theme.font.fontWeight.bold,
    color: theme.colors.application.typography.default,
  },
}));

interface IncomingInvoiceDrawerSectionHeaderProps {
  title: string;
  mode?: 'view' | 'edit';
  setMode?: (mode: 'view' | 'edit') => void;
  className?: string;
  iconProp?: IconProp;
  disableEdit?: boolean;
}

export const IncomingInvoiceDrawerSectionHeader: React.FC<
  IncomingInvoiceDrawerSectionHeaderProps
> = (props) => {
  //#region ------------------------------ Defaults
  const { className, title, iconProp, disableEdit, mode, setMode } = props;
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();
  const { t } = useTranslation();
  //#endregion

  return (
    <Flex.Row
      alignItems="center"
      justifyContent="space-between"
      className={classNames(classes.sectionHeader, className)}
    >
      <Flex.Row alignItems="center" childrenGap={8}>
        {iconProp ? (
          <FontAwesomeIcon
            icon={iconProp}
            style={{ color: theme.colors.application.typography.default }}
          />
        ) : null}
        <span className={classes.sectionHeading}>{title}</span>
      </Flex.Row>
      {disableEdit ? null : (
        <Button type="link" iconProp={['fal', 'pen']}>
          {mode === 'view' ? (
            <span onClick={() => setMode('edit')}>
              {t('accounting:incomingInvoices.drawerSteps.edit')}
            </span>
          ) : (
            <span onClick={() => setMode('view')}>
              {t('accounting:incomingInvoices.drawerSteps.finishEditing')}
            </span>
          )}
        </Button>
      )}
    </Flex.Row>
  );
};

export default IncomingInvoiceDrawerSectionHeader;
